<template>
  <div class="custom-swiper-wrap" :class="{ mb_show_sides: mb_show_sides&&!not_swiper}">
    <div class="navigation" :class="[button_type]" v-if="!not_swiper">
      <button 
        @click.stop.prevent="prev" 
        class="custom-swiper-prev" 
        :style="click_num <= 0?'color: #cccccc;':''"
      >
        <slot name="prev">
          <svg viewBox="0 0 100 100">
            <path
              d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z"
              class="arrow"
            ></path>
          </svg>
        </slot>
      </button>
      <button
        @click.stop.prevent="next"
        class="custom-swiper-next"
        :style="click_num >= click_able?'color: #cccccc;':''"
      >
        <slot name="next">
          <svg viewBox="0 0 100 100">
            <path
              d="M 20,50 L 60,90 L 60,85 L 25,50  L 60,15 L 60,10 Z"
              class="arrow"
              transform="translate(100, 100) rotate(180) "
            ></path>
          </svg>
        </slot>
      </button>
    </div>
    <div
      class="custom-swiper"
      :class="{ 'swiper-touch-scroll': touchScroll }"
      @touchstart="!touchScroll && startMove()"
      @touchend="!touchScroll && endMove()"
    >
      <div
        class="custom-swiper-content"
        ref="swiper"
        :style="{transform: `translateX(-${offset_val}%)`}"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    total_num: {
      type: Number, //元素数量
      require: true,
    },
    page_num: {
      type: Number, //初始展示个数
      require: true,
    },
    mb_page_num: {
      type: Number, //移动端展示个数
    },
    button_type: {
      type: String, // 默认两边 圆形按钮|| welt 长条透明按钮 || label_button 按钮会在两边占位
    },
    mb_show_sides: {
      type: Boolean, //移动端展示两边
    },
    not_swiper: {
      type: Boolean, //禁用轮播图功能
    },
    touchScroll:{
      type: Boolean
    },
    itemSize:{
      type:Object
    },
  },
  data() {
    return {
      click_num: 0,
      innerWidth: 0,
      startX: 0,
    };
  },
  computed: {
    current_page_num() {
      //移动端展示数量
      if (this.innerWidth < 768 && this.mb_page_num) {
        return this.mb_page_num;
      } else {
        return this.page_num;
      }
    },
    click_able() {
      //let num = parseInt(this.total_num / this.current_page_num);
      let num  = Math.ceil(this.total_num/Math.floor(this.current_page_num)-1)
      //可点击数
      return this.remainder == "0" ? num - 1 : num;
    },
    remainder() {
      return this.total_num % this.current_page_num;
    },
    offset_base() {
      //每次偏移多少百分比
      return (1 / this.current_page_num) * 100;
    },
    offset_val() {
      let val = 0;
      let a = Math.floor(this.current_page_num)
      val = this.click_num * (Math.ceil(a/this.current_page_num*100));
      if (this.click_num == this.click_able && this.remainder > 0) {
        //val = val - (this.current_page_num - this.remainder) * this.offset_base;
        val = Math.ceil(((this.total_num * this.itemSize.width - this.itemSize.marginRight) / (this.current_page_num * this.itemSize.width) - 1) * 100)
      }
      return val > 0 ? val : 0;
    },
  },
  mounted() {
    let get_innerWidth = this.debounce(() => {
      this.innerWidth = window.innerWidth;
    }, 200);
    get_innerWidth();
    window.addEventListener("resize", get_innerWidth);
  },
  methods: {
    prev() {
      if (this.click_num > 0) {
        this.click_num--;
      }
    },
    next() {
      if (this.click_num < this.click_able) {
        this.click_num++;
      }
    },
    startMove(e) {
      if (this.not_swiper || !e || !e.changedTouches) return;
      this.startX = e.targetTouches[0].clientX; // 获取触控时x坐标
    },
    endMove(e) {
      if (this.not_swiper || !e || !e.changedTouches) return;
      let endX = e.changedTouches[0].clientX;
      let distance = endX - this.startX;
      if (distance > 50) {
        this.prev();
      } else if (distance < -50) {
        this.next();
      }
    },
  },
};
</script>
<style scoped lang='scss'>
.custom-swiper-wrap {
  position: relative;
  width: 100%;
  .navigation {
    button:focus{
      outline: none !important;
    }
    .custom-swiper-prev,
    .custom-swiper-next {
      top: 22%;
    }
    .custom-swiper-prev {
      left: -22px;
    }
    .custom-swiper-next {
      right: 10px;
    }
  }
  &:hover {
    .welt {
      .custom-swiper-prev,
      .custom-swiper-next {
        visibility: visible !important;
      }
    }
  }
  .navigation.welt {
    .custom-swiper-prev,
    .custom-swiper-next {
      visibility: hidden;
      width: 46px;
      height: 100%;
      border-radius: 0;
      box-shadow: none;
      top: 0;
      opacity: 0.7;
      text-align: center;
    }
    .custom-swiper-prev {
      left: 0;
      margin-left: 10px;
      box-shadow: -10px 0 0px #fff;
    }
    .custom-swiper-next {
      right: 0;
      margin-right: 10px;
      box-shadow: 10px 0 0px #fff;
    }
  }
  .navigation.label_button {
    .custom-swiper-prev,
    .custom-swiper-next {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20%;
      top: 0;
      border-radius: 0;
      height: 100%;
      box-shadow: none;
      background-color: transparent;
    }
    .custom-swiper-prev {
      left: 0;
    }
    .custom-swiper-next {
      right: 0;
    }
  }
  .custom-swiper {
    display: inline-block;
    width: 100%;
    overflow-x: hidden;
    .custom-swiper-content {
      transition: all 0.5s;
    }
  }
  .swiper-touch-scroll {
    overflow-x: auto;
    &::-webkit-scrollbar {
      width: 0 !important;
      height: 0 !important;
    }
  }
}
@media screen and (max-width: 768px) {
  .custom-swiper-wrap {
    .navigation {
      & > button {
        width: 32px;
        height: 32px;
        line-height: 12px;
        svg {
          height: 12px;
        }
      }
      .custom-swiper-prev {
        left: -15px;
      }
      .custom-swiper-next {
        right: 0;
      }
    }
    .navigation.welt {
      & > button {
        display: none;
      }
    }
  }
  .mb_show_sides {
    .custom-swiper {
      padding-left: 10%;
      padding-right: 10%;
    }
  }
}
</style>